var _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 39.5,
    fill: "#F2F5F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 39.5,
    stroke: "#003C8A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40,
    r: 39.5,
    stroke: "white",
    strokeOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 54.8332L48.75 46.5832C50.3815 44.9516 51.4925 42.8728 51.9426 40.6097C52.3927 38.3466 52.1615 36.0009 51.2785 33.8692C50.3954 31.7374 48.9001 29.9154 46.9815 28.6335C45.063 27.3516 42.8074 26.6674 40.5 26.6674C38.1926 26.6674 35.937 27.3516 34.0185 28.6335C32.0999 29.9154 30.6046 31.7374 29.7215 33.8692C28.8385 36.0009 28.6074 38.3466 29.0574 40.6097C29.5075 42.8728 30.6185 44.9516 32.25 46.5832L40.5 54.8332ZM40.5 59.5466L29.8933 48.9399C27.7956 46.8421 26.367 44.1694 25.7882 41.2597C25.2095 38.35 25.5065 35.334 26.6418 32.5931C27.7772 29.8522 29.6997 27.5095 32.1665 25.8613C34.6332 24.2131 37.5333 23.3334 40.5 23.3334C43.4667 23.3334 46.3668 24.2131 48.8335 25.8613C51.3003 27.5095 53.2229 29.8522 54.3582 32.5931C55.4935 35.334 55.7906 38.35 55.2118 41.2597C54.633 44.1694 53.2044 46.8421 51.1067 48.9399L40.5 59.5466ZM40.5 41.6666C41.3841 41.6666 42.2319 41.3154 42.857 40.6903C43.4821 40.0651 43.8333 39.2173 43.8333 38.3332C43.8333 37.4492 43.4821 36.6013 42.857 35.9762C42.2319 35.3511 41.3841 34.9999 40.5 34.9999C39.616 34.9999 38.7681 35.3511 38.143 35.9762C37.5179 36.6013 37.1667 37.4492 37.1667 38.3332C37.1667 39.2173 37.5179 40.0651 38.143 40.6903C38.7681 41.3154 39.616 41.6666 40.5 41.6666ZM40.5 44.9999C38.7319 44.9999 37.0362 44.2975 35.786 43.0473C34.5357 41.797 33.8333 40.1014 33.8333 38.3332C33.8333 36.5651 34.5357 34.8694 35.786 33.6192C37.0362 32.369 38.7319 31.6666 40.5 31.6666C42.2681 31.6666 43.9638 32.369 45.2141 33.6192C46.4643 34.8694 47.1667 36.5651 47.1667 38.3332C47.1667 40.1014 46.4643 41.797 45.2141 43.0473C43.9638 44.2975 42.2681 44.9999 40.5 44.9999Z",
    fill: "#003C8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.78d0d83d742c803f7706e6ce7ac82c57.svg";
export { ForwardRef as ReactComponent };